import React from "react";
import BespokeWizard from "@/components/bespoke/BespokeWizard";
import { BESPOKE_CATEGORIES } from "@/lib/bespokeCategories";
import { HipShapeIcon } from "@/components/bespoke/ShirtIcons";
import { TrouserFitIcon, PleatIcon, TrouserPocketIcon, WaistbandIcon, HemIcon } from "@/components/bespoke/GarmentIcons";

const FIT_OPTIONS = [{ key: "slim", label: "Slim" }, { key: "regular", label: "Regular" }, { key: "relaxed", label: "Relaxed" }];
const PLEAT_OPTIONS = [{ key: "flat", label: "Flat Front" }, { key: "single", label: "Single Pleat" }, { key: "double", label: "Double Pleat" }];
const POCKET_OPTIONS = [{ key: "slant", label: "Slant Pocket" }, { key: "straight", label: "Straight Pocket" }, { key: "coin", label: "Coin Pocket" }];
const WAISTBAND_OPTIONS = [{ key: "standard", label: "Standard", price: 0 }, { key: "extended", label: "Extended Tab", price: 150 }, { key: "elastic", label: "Elastic Comfort", price: 200 }];
const HEM_OPTIONS = [{ key: "plain", label: "Plain Hem" }, { key: "cuffed", label: "Cuffed Hem" }];
const HIP_OPTIONS = [
  { key: "flat", label: "Flat Hip", help: "Straighter hip line." },
  { key: "standard", label: "Standard Hip", help: "Average hip curve." },
  { key: "heavy", label: "Heavy Hip", help: "Fuller hip curve." },
];

const config = {
  garmentType: "trousers",
  title: "Custom Trousers",
  prefix: "trousers",
  guideCaption: "For optimal fit, we recommend measuring from your best-fitting trousers.",
  faqs: BESPOKE_CATEGORIES.trousers.faqs,
  groups: [
    { group: "lower_body_shape", label: "Lower Body Shape *", options: HIP_OPTIONS, Icon: HipShapeIcon, default: "standard" },
    { group: "trouser_fit", label: "Fit", options: FIT_OPTIONS, Icon: TrouserFitIcon, default: "regular" },
    { group: "pleat", label: "Pleat", options: PLEAT_OPTIONS, Icon: PleatIcon, default: "flat" },
    { group: "trouser_pocket", label: "Pocket", options: POCKET_OPTIONS, Icon: TrouserPocketIcon, default: "slant" },
    { group: "waistband", label: "Waistband", options: WAISTBAND_OPTIONS, Icon: WaistbandIcon, default: "standard", showPrice: true, addon: true },
    { group: "hem", label: "Hem", options: HEM_OPTIONS, Icon: HemIcon, default: "plain", cols: "grid-cols-2", maxWidth: "max-w-sm" },
  ],
  sizes: ["28", "30", "32", "34", "36", "38", "40", "42", "44", "46"],
  sizeChart: {
    columns: ["To Fit Waist (in)", "Outseam Length (in)"],
    rows: [
      { size: "28", values: [30, 40] },
      { size: "30", values: [32, 40] },
      { size: "32", values: [34, 40] },
      { size: "34", values: [36, 40] },
      { size: "36", values: [38, 42] },
      { size: "38", values: [40, 42] },
      { size: "40", values: [42, 42] },
      { size: "42", values: [44, 42] },
      { size: "44", values: [46, 42] },
      { size: "46", values: [48, 42] },
    ],
  },
  measureFields: [
    { key: "body_height", label: "Body Height *", type: "text", target: "style", required: true },
    { key: "waist", label: "Waist (in) *", target: "meas", required: true },
    { key: "seat", label: "Seat / Hip (in) *", target: "meas", required: true },
    { key: "trouser_inseam", label: "Inseam (in) *", target: "meas", required: true },
    { key: "thigh", label: "Thigh (in)", target: "meas" },
  ],
};

export default function BespokeTrousers() {
  return <BespokeWizard config={config} />;
}
